import { FlightChangesCasesUnavailable } from './FlightChangesCasesUnavailable';

export const ErrorMessage = () => <FlightChangesCasesUnavailable />;

